<template>
  <div class="container-tips container-general">
    <section-title-after title="Tips & Tricks"></section-title-after>

    <div v-if="hasCustomContent" class="content-tips" v-html="customTricksGeneric"></div>

    <div v-else>
      <div class="content-tips" v-if="type !== 'ruote-classiche'">
        <div class="title-tips">
          Consigli utili per vendere a privati
        </div>
        <div class="content-tips-list" v-html="defaultTips"></div>
      </div>

      <div class="content-tips" v-if="type !== 'ruote-classiche'">
        <div class="title-tips">
          Consigli utili per vendere ad un professionista (permuta)
        </div>
        <div class="content-tips-list" v-html="defaultProfessionalTips"></div>
      </div>

      <div class="content-tips" v-if="type === 'ruote-classiche'">
        <div class="content-tips-list" v-html="classicTips"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TipsTricks',
  props: {
    type: {
      type: String,
      required: true,
    },
    customTricksGeneric: {
      type: String,
      default: '',
    },
  },
  computed: {
    hasCustomContent() {
      const plain = this.customTricksGeneric.replace(/<[^>]+>/g, '').trim();
      // Se il contenuto è vuoto oppure equivale a "<p><br></p>" (eventualmente con spazi) lo consideriamo vuoto
      return (
        plain !== '' && this.customTricksGeneric.replace(/\s/g, '').toLowerCase() !== '<p><br></p>'
      );
    },
    defaultTips() {
      return `
          <ul>
            <li>Accertati di avere tutti i documenti necessari per il passaggio di proprietà (certificato di proprietà e libretto di circolazione)</li>
            <li>Presenta al meglio la tua auto, lavata e con interni puliti e ordinati; alcuni interventi estetici richiedono poca spesa, ma rendono molto più desiderabile il veicolo</li>
            <li>È preferibile che tutti gli interventi di riparazione, manutenzione e controllo di qualità siano documentati (libretto dei tagliandi e fatture degli interventi); questo renderà la trattativa più semplice</li>
            <li>Gli pneumatici devono avere il battistrada almeno al limite di legge (per la nostra quotazione almeno al 50%)</li>
            <li>Ricordati di segnalare la presenza di tutte le dotazioni accessorie (ruota di scorta o ruotino, seconda chiave, catene neve, ecc.). Segnala anche il treno di gomme invernali, se disponibile</li>
            <li>Gli equipaggiamenti opzionali, anche se non valorizzati nella quotazione, possono rendere più interessante il veicolo al compratore. Indicali sempre</li>
            <li>Prima di firmare il passaggio di proprietà accertati dell’effettiva solvibilità del pagamento, se non conosci il cliente</li>
          </ul>
        `;
    },
    defaultProfessionalTips() {
      return `
          <ul>
            <li>La quotazione di ritiro sconta, oltre i costi gestionali e finanziari che il concessionario o rivenditore deve sostenere, anche i rischi d’impresa e il legittimo guadagno dell’imprenditore</li>
            <li>In fase di contrattazione, fai chiaramente indicare lo sconto dell’auto nuova e la quotazione del tuo usato, solo così potrai confrontare diverse offerte</li>
            <li>Accertati di avere tutti i documenti per il passaggio di proprietà (certificato di proprietà e libretto di circolazione)</li>
            <li>In fase contrattuale non nascondere alcun problema o danno presente sulla vettura, il concessionario in fase di effettivo ritiro dell’auto potrebbe riconsiderare la valutazione</li>
            <li>Ricordati che la seconda chiave è una dotazione obbligatoria, è necessario consegnarla per non doversi accollare il costo</li>
            <li>Se l’auto è intestata ad una azienda dovrà essere fatturata; in questo caso è meglio farsi specificare il valore dell’usato senza IVA</li>
          </ul>
        `;
    },
    classicTips() {
      return `
          <ul>
            <li>Il valore di mercato di un'auto storica è fortemente influenzato dall'essere appartenuto a un personaggio famoso, soprattutto se il proprietario è direttamente legato alla storia dell'automobile.</li>
            <li>Il valore di una perizia assicurativa permette di dormire sonni tranquilli in caso di incidente, perché l'assicurazione rimborsa i danni al 100% sulla base della documentazione peritale.</li>
            <li>L'esenzione dal bollo è, per il momento, ottenibile soltanto quando l'auto supera i 30 anni dalla costruzione. In Lombardia e in Emilia, oltre che in alcune provincie autonome, l'esenzione è concessa anche alle ultraventennali.</li>
            <li>Il mercato delle youngtimer è uno dei più vivaci al momento. Privilegiate dai collezionisti italiani sono le auto di produzione italiana (in particolare le sportive) e quelle tedesche</li>
            <li>Il mercato delle youngtimer in Italia ha valori di mercato calmierati rispetto a quanto awiene in altri Paesi europei (in particolare Germania e Olanda).</li>
            <li>Attenzione che per i modelli con età inferiore ai 20 anni (ma in alcuni casi anche per alcune auto con età inferiore ai 30 anni) non sono molte le Compagnie d'Assicurazione che propongono polizze agevolate.</li>
            <li>Il vero problema di molte youngtimer da collezione consiste nella presenza di sistemi elettronici, che hanno un ciclo di vita medio inferiore ad altre parti dell'auto. Oggi sono pochi i riparatori specializzati e non sempre sono disponibili ricambi.</li>
            <li>Ben difficilmente una youngtimer viene sottoposta a un restauro radicale: in genere i collezionisti sono alla ricerca di esemplari conservati.</li>
            <li>Una delle maggiori problematiche nel ripristino di una youngtimer consiste nel restauro degli interni: le stoffe dei rivestimenti non sono sempre reperibili e l'utilizzo abbondante di plastiche di qualità bassa potrebbe creare ulteriori difficoltà.</li>
          </ul>
        `;
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/TipsTricks.vue